module.exports = __webpack_public_path__ + "img/savings-icon.d9a9c54d.svg";